module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.list), function(item, index) {
    return _c('router-link', {
      key: index,
      staticClass: "list ",
      attrs: {
        "to": {
          name: 'detail',
          params: {
            id: item.groupbuy_info.item_info.item_id
          }
        },
        "tag": "div"
      }
    }, [_c('div', {
      staticClass: "top vux-1px-b flex"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      staticClass: "img-block",
      attrs: {
        "src": item.groupbuy_info.groupbuy_image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "l flex-1 text-l flex"
    }, [_c('span', {
      staticClass: "title "
    }, [_vm._v(_vm._s(item.groupbuy_info.groupbuy_title))]), _vm._v(" "), _c('div', {
      staticClass: "flex price"
    }, [_c('span', {
      staticClass: "red"
    }, [_vm._v("￥" + _vm._s(item.groupbuy_info.groupbuy_price))]), _vm._v(" "), _c('span', {
      staticClass: "person flex-1"
    }, [_vm._v(_vm._s(item.groupbuy_info.groupbuy_num) + " 人团")]), _vm._v(" "), _c('span', {
      staticClass: "red text"
    }, [_vm._v(_vm._s(_vm._f("status")(item.grouplog_info.status)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "btm"
    }, [_c('router-link', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.grouplog_info.status == 2),
        expression: "item.grouplog_info.status==2"
      }],
      attrs: {
        "tag": "span",
        "to": {
          name: 'courierInfo',
          params: {
            tid: item.grouplog_info.tid
          }
        }
      }
    }, [_vm._v("查看物流")]), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.openUrl('spellGroupDetail', item.grouplog_info.group_id, item.grouplog_info.groupbuy_id)
        }
      }
    }, [_vm._v("查看团详情")]), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.openUrl('spellGroupOrderDetail', item.grouplog_info.tid)
        }
      }
    }, [_vm._v("查看订单详情")])], 1)])
  }), _vm._v(" "), _c('no-data', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.list.length == 0),
      expression: "list.length==0"
    }]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-777082d4"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCenter/spellGroup/list.vue
// module id = 585
// module chunks = 0